<a (click)="toggle.emit()"
   tooltip="Show/hide controls"
   i18n-tooltip="@@topPanel.controlsToggle.tooltip"
   placement="bottom"
   title="Show controls"
   i18n-title="@@topPanel.controlsToggle.title">
  <i class="fa fa-bars fa-2x text-primary mx-1"></i>
</a>
